import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

import UserModel from '../models/User';
import ProjectAdministratorStaff from 'src/models/ProjectAdministratorStaff';
import ProjectStaff from 'src/models/ProjectStaff';

export interface IUser {
    getPaged(options: ODataOptions, jwt: string): Promise<object>;
    getAll(jwt: string): Promise<object>;
    get(id: number, jwt: string): Promise<object>;
    create(user: UserModel, jwt: string): Promise<object>;
    edit(user: UserModel, jwt: string): Promise<object>;
    getRoles(jwt: string): Promise<object>;
    getProjectAdministrationTypes(jwt: string): Promise<object>;
    addUserToProjectAdministration(
        payload: { clientNumber: number; projectNumber: number; staffInfo: ProjectAdministratorStaff },
        jwt: string
    ): Promise<object>;
    addLandmanToStaff(payload: { clientNumber: number; projectNumber: number; staffInfo: ProjectStaff }, jwt: string): Promise<object>;
}

export default class User extends BaseApi implements IUser {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    getPaged = (options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/users${options.toString()}`, jwt);
    };

    getAll = (jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/users/user-list`, jwt);
    };

    get = (id: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/users/${id}`, jwt);
    };

    create = (user: UserModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/users`, user, jwt);
    };

    edit = (user: UserModel, jwt: string) => {
        return this.putRequest(`${this.baseUrl}v1.0/users`, user, jwt);
    };

    getRoles = (jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/users/roles`, jwt);
    };

    getProjectAdministrationTypes = (jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/users/pm-types`, jwt);
    };

    addUserToProjectAdministration = (
        payload: { clientNumber: number; projectNumber: number; staffInfo: ProjectAdministratorStaff },
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${payload.clientNumber}/projects/${payload.projectNumber}/projectstaff/administration/`,
            payload.staffInfo,
            jwt
        );
    };

    addLandmanToStaff = (payload: { clientNumber: number; projectNumber: number; staffInfo: ProjectStaff }, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${payload.clientNumber}/projects/${payload.projectNumber}/projectstaff/staffing/`,
            payload.staffInfo,
            jwt
        );
    };
}



// WEBPACK FOOTER //
// ./src/api/User.ts